module.exports = __webpack_public_path__ + "static/media/Programming in Java.1c4e2fe8.jpg";